// @ts-nocheck
import {faCalendar, faPaw, faTicketAlt, faTrophy} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {getLatestAnimalitoResults, getLatestLotteryResults, getTodayFormatted} from "../utils/generateLotteryData";
import * as styles from "./_lovenPagesCls";

const Home = () => {
  const navigate = useNavigate();
  const [animalitoResults, setAnimalitoResults] = useState([]);
  const [lotteryResults, setLotteryResults] = useState([]);

  useEffect(() => {
    // Generate results on component mount
    setAnimalitoResults(getLatestAnimalitoResults(3));
    setLotteryResults(getLatestLotteryResults(3));
  }, []);

  return (
    <div className={styles.pageContainerCls}>
      <div className={styles.headerCls}>
        <div className={styles.headerIconCls}>
          <FontAwesomeIcon icon={faTrophy} />
        </div>
        <h1 className={styles.titleCls}>Resultados de Hoy</h1>
        <div className={styles.dateContainerCls}>
          <FontAwesomeIcon
            icon={faCalendar}
            className={styles.calendarIconCls}
          />
          <p className={styles.dateCls}>{getTodayFormatted()}</p>
        </div>
      </div>

      {/* Animalitos Section */}
      <section className={styles.sectionCls}>
        <div className={styles.sectionHeaderCls}>
          <div className={styles.sectionTitleContainerCls}>
            <FontAwesomeIcon
              icon={faPaw}
              className={styles.sectionIconCls}
            />
            <h2 className={styles.sectionTitleCls}>Animalitos</h2>
          </div>
          <button
            type="button"
            className={styles.viewAllButtonCls}
            onClick={() => navigate("/lotoven/animalitos")}
          >
            Ver todos →
          </button>
        </div>

        <div className={styles.resultsGridCls}>
          {animalitoResults.map((result, index) => (
            <div
              key={`animalito-${index++}`}
              className={styles.resultCardCls}
            >
              <div className={styles.resultTimeCls}>{result.time}</div>
              <div className={styles.animalNumberBigCls}>{result.result.number}</div>
              <div className={styles.animalNameCls}>{result.result.name}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Loterias Section */}
      <section className={styles.sectionCls}>
        <div className={styles.sectionHeaderCls}>
          <div className={styles.sectionTitleContainerCls}>
            <FontAwesomeIcon
              icon={faTicketAlt}
              className={styles.sectionIconCls}
            />
            <h2 className={styles.sectionTitleCls}>Loterías</h2>
          </div>
          <button
            type="button"
            className={styles.viewAllButtonCls}
            onClick={() => navigate("/lotoven/loterias")}
          >
            Ver todos →
          </button>
        </div>

        <div className={styles.resultsGridCls}>
          {lotteryResults.map((result, index) => (
            <div
              key={`lottery-${index++}`}
              className={styles.resultCardCls}
            >
              <div className={styles.lotteryNameCls}>{result.name}</div>
              <div className={styles.resultTimeCls}>{result.time}</div>
              <div className={styles.lotteryNumbersCls}>
                {result.numbers.map((num, idx) => (
                  <span
                    key={idx++}
                    className={styles.lotteryNumberCls}
                  >
                    {num}
                  </span>
                ))}
              </div>
              <div className={styles.serialCls}>Serie: {result.serial}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Info Banner */}
      <div className={styles.infoBannerCls}>
        <p>🎲 Los resultados se actualizan automáticamente con la fecha de hoy</p>
      </div>
    </div>
  );
};

export default Home;
